import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChargeCardComponent } from './demo/charge-card/charge-card.component';
import { SaveCardComponent } from './demo/save-card/save-card.component';
import { ReadMeComponent } from './demo/read-me/read-me.component';
import { SubscriptionPageComponent } from './demo/subscription-page/subscription-page.component';
import { StripeDashboardComponent } from './demo/stripe-dashboard/stripe-dashboard.component';
import { ConnectPageComponent } from './demo/connect-page/connect-page.component';
import { ConnectRedirectComponent } from './payment/connect-redirect/connect-redirect.component';

import { AuthGuard } from './core/auth.guard';
import { AuthenticateComponent } from "./pages/authenticate/authenticate.component";
import { CheckitDashboardComponent } from "./pages/checkit-dashboard/checkit-dashboard.component";
import { PricingComponent } from "./pages/pricing/pricing.component";
import { PublicGuard } from "./core/public.guard";
import { AccountComponent } from "./pages/account/account.component";
import { RsvpComponent } from './pages/rsvp/rsvp.component';
import { CheckinComponent } from './pages/checkin/checkin.component';

const routes: Routes = [
    { path: '', component: AuthenticateComponent, data: {is_create_user: true}, canActivate:[PublicGuard] },
    { path: 'auth', component: AuthenticateComponent, data: {is_create_user: true}, canActivate:[PublicGuard]  },
    { path: 'pricing', component: PricingComponent },
    { path: 'my_account', component: AccountComponent, canActivate: [AuthGuard] },
    { path: 'my_account/:viewDetails', component: AccountComponent, canActivate: [AuthGuard] },
    { path: 'create_account', component: AuthenticateComponent, data: {is_create_user: true}, canActivate:[PublicGuard] },
    { path: 'login', component: AuthenticateComponent, data: {is_create_user: false}, canActivate:[PublicGuard] },
    { path: 'charge', component: ChargeCardComponent, canActivate: [AuthGuard]  },
    { path: 'save-card', component: SaveCardComponent, canActivate: [AuthGuard]  },
    { path: 'subscription', component: SubscriptionPageComponent, canActivate: [AuthGuard]  },
    { path: 'dashboard', component: StripeDashboardComponent, canActivate: [AuthGuard]  },
    { path: 'checkit-dashboard', component: CheckitDashboardComponent, canActivate: [AuthGuard]  },
    { path: 'checkit-event/:eventId', component: CheckitDashboardComponent, canActivate: [AuthGuard]  },
    { path: 'rsvp/:rsvpId', component: RsvpComponent },
    { path: 'rsvp', component: RsvpComponent },
    { path: 'check-in/:checkinId', component: CheckinComponent, data: {checkin: true}},


    // Stripe Connect
    { path: 'connect', component: ConnectPageComponent  },
    { path: 'redirect', component: ConnectRedirectComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts